const adminPanel = {
  adminPanel: {
    einAdmin: 'Admin EIN',
    einInstallerSetup: 'Configuração do instalador EIN',
    installerDataUpdate: 'Atualização de dados da instaladora',
    uploadFile: 'Carregar arquivo',
    chooseFile: 'Escolher arquivo',
    installerDataUpdateDescription: 'Participação de mercado da instaladora da Enphase, informações do patrocinador executivo, etc.',
    header: 'Links da barra de cabeçalho',
    platinumTier: 'Nível Platina',
    goldTier: 'Nível Ouro',
    silverTier: 'Nível Prata',
    same: 'O mesmo para todos os níveis',
    bannerDescription: 'Descrição do Banner',
    bannerLink: 'Link do Banner',
    digitalAssets: 'Ativos digitais',
    name: 'Nome',
    file: 'Arquivo',
    access: 'Acesso à categoria de nível',
    action: 'Ação',
    all: 'Todos',
    platinum: 'Platina',
    gold: 'Ouro',
    silver: 'Prata',
    addDigital: 'Adicionar ativos digitais',
    productInformation: 'Informações do produto',
    productName: 'Nome do produto',
    learnMoreLink: 'Saiba mais',
    featureName: 'Nome do recurso A/B',
    featureType: 'Tipo de recurso',
    betaRelease: 'Data de lançamento beta',
    addProduct: 'Adicionar informações do produto',
    exclusiveUpdate: 'Links de atualização exclusivos',
    description: 'Descrição',
    link: 'Link',
    addLink: 'Adicionar Link',
    one: '1',
    two: '2',
    installerList: 'Lista de instaladoras para acesso ao produto',
    usa: 'EUA',
    usa_pr: 'EUA - Porto Rico',
    australia: 'Austrália',
    belgium: 'Bélgica',
    netherlands: 'Países Baixos',
    germany: 'Alemanha',
    india: 'Índia',
    mexico: 'México',
    //TODO: translations
    france: 'France',
    //TODO: translations ends
    country: 'País',
    fileName: 'Nome do arquivo',
    software_service: 'SOFTWARE_SERVICE',
    hardware_product: 'HARDWARE_PRODUCT',
    empty_file: 'O arquivo está vazio',
    invalidFileFormat: 'Formato de arquivo inválido',
    invalidFileHeader: 'Cabeçalho de arquivo inválido',
    uploadFailed: 'Falha ao carregar o arquivo',
    invalidFile: 'Arquivo inválido',
    errorDetail: {
      one: '%{errorCount} fora da %{count} linha falhou.',
      other: '%{errorCount} fora das %{count} linhas falhou.'
    },
    viewError: 'Ver erros',
    errorListText: 'Lista de erros de upload de arquivos',
    companyId: 'ID da empresa',
    message: 'Mensagem',
    sampleFileName: 'Arquivo de amostra'
  }
};

export default adminPanel;